import { render, staticRenderFns } from "@/style-guide/partials/ship/ship.pug?vue&type=template&id=e24d6524&scoped=true&lang=pug&external"
import script from "./ship.vue?vue&type=script&lang=ts"
export * from "./ship.vue?vue&type=script&lang=ts"
import style0 from "./ship.vue?vue&type=style&index=0&id=e24d6524&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24d6524",
  null
  
)

export default component.exports